import { CustomType } from '../models/models';
import { isObjKey } from './utils';

export class Sanitizer {
    // Escape special characters in a string
    private escapeString(input: string): string {
        return input
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
            .replace(/`/g, '&#96;')
            .replace(/\\/g, '&#92;')
            .replace(/%/g, '&#37;')
            .replace(/\r?\n/g, '<br>');
    }

    // Recursively sanitize an object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sanitize(data: CustomType): string | { [key: string]: any } {
        if (typeof data === 'string') {
            return this.escapeString(data);
        } else if (typeof data === 'object' && data != null) {
            const sanitizedObject: CustomType = {};
            for (const key in data) {
                if (isObjKey(key, data)) {
                    const sanitizedKey = this.escapeString(key);
                    sanitizedObject[sanitizedKey] = this.sanitize(data[key]);
                }
            }
            return sanitizedObject;
        }
        return data ?? '';
    }
}
